// removed by extract-text-webpack-plugin
module.exports = {"tipsWrap":"Tips-tipsWrap","block":"Tips-block","success-block":"Tips-success-block","failed-block":"Tips-failed-block","content":"Tips-content"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Tips/index.css
// module id = 1744
// module chunks = 0